import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, onMounted, ref } from "vue"
  import { useRoute, useRouter } from "vue-router"
  import { useMetadataStore } from "@/store/metadata"
  import { getContent, RenderContent, isPreviewing } from "@builder.io/sdk-vue/vue3"
  import { IonContent } from "@ionic/vue"
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcesPage',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const metadata = useMetadataStore()
  const canShowContent = ref(false)
  const content = ref<any>(null)
  const apiKey = computed(() => process.env.VUE_APP_RESOURCES_KEY)

  const meta = ref({
    title: "",
    type: "article",
    description: "",
    image: "",
    url: window.location.href,
    site: window.location.href,
  })
  onMounted(() => {
    if (!route.params.slug) {
      getContent({
        model: "page",
        apiKey: apiKey.value,
        userAttributes: {
          urlPath: `/${route.params.type}`,
        },
      }).then((res: any) => {
        content.value = res
        canShowContent.value = content.value || isPreviewing()
        if (!canShowContent.value) router.push("/not-found")
        if (content.value) {
          router.push(`/resources/${content.value.data.format.toLowerCase()}/${route.params.type}`)
        }
      })
    } else {
      getContent({
        model: "page",
        apiKey: apiKey.value,
        userAttributes: {
          urlPath: `/${route.params.slug}`,
        },
      }).then((res: any) => {
        content.value = res
        canShowContent.value = content.value || isPreviewing()
        if (!canShowContent.value) router.push("/not-found")
        if (content.value) {
          if (content.value.data.format.toLowerCase() !== route.params.type) router.push(`/resources/${content.value.data.format.toLowerCase()}/${route.params.slug}`)
          else {
            meta.value.title = content.value.data?.title
            meta.value.description = content.value.data?.description
            meta.value.image = content.value.data?.image
            metadata.details.title = meta.value.title
            metadata.details.description = meta.value.description
            metadata.details.og = { ...metadata.details.og, ...meta.value }
            metadata.details.twitter = { ...metadata.details.twitter, ...meta.value }
          }
        }
      })
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), { class: "resources-page ion-padding" }, {
    default: _withCtx(() => [
      (canShowContent.value)
        ? (_openBlock(), _createBlock(_unref(RenderContent), {
            key: 0,
            model: "page",
            content: content.value,
            "api-key": _unref(apiKey),
            class: "pb-14"
          }, null, 8, ["content", "api-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})